import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import BookingForm from "@/pages/BookingForm";
import Payment from "@/pages/Payment";
import BookingConfirmation from "@/pages/BookingConfirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AllCourtsAvailability from "@/pages/AllCourtsAvailability";
import OpenPlaysRedirect from "@/pages/OpenPlaysRedirect";
import EventsPage from "@/pages/EventsPage";
import RequireAdmin from "@/components/RequireAdmin";
import { installAdminAuthInterceptor } from "@/lib/adminAuth";

// Register the admin-auth axios interceptor once at module load so every
// axios call in the app (from any page) picks up the bearer token and
// handles 401s consistently.
installAdminAuthInterceptor();

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* /courts is the legacy "Per Court" view — kept as a redirect so
              existing bookmarks/links still resolve to All Courts. */}
          <Route path="/courts" element={<Navigate to="/availability" replace />} />
          <Route path="/availability" element={<AllCourtsAvailability />} />
          {/* /special-rental removed — Special Court Rental deprecated;
              redirect any legacy bookmarks back to the main availability page. */}
          <Route path="/special-rental" element={<Navigate to="/availability" replace />} />
          <Route path="/op" element={<OpenPlaysRedirect />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/booking/:courtId" element={<BookingForm />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment/:bookingId" element={<Payment />} />
          <Route path="/booking-confirmation" element={<BookingConfirmation />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
